module.exports = __webpack_public_path__ + "media/images/mobile/Slider9-06efe77769e0aab9cbe59f9904d9bf81.png";